import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonUtility, ResetPasswordVO, User } from '../shared';
import { DateUtility, ServerConstantsService, AuthService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordVO: ResetPasswordVO;
  user: User;

  ServerConstants: any;

  userActionNotificationsMap: any;


  isResetDisable: Boolean = true;
  isView: Boolean = true;
  sharedData: any;
  reTypePassword: any;
  isSaveDisable: Boolean = true;
  firstName: string;
  lastName: string;
  tempPasswordSw: string;
  confirmPassword: string;
  confirmNewPassword: string;
  newPassword: string;
  tempPassword: string;
  confirmTempPassword: string;
  currentPassword: string;
  public barLabel: String = 'Password strength:';
  public myColors = ['#DD2C00', '#FF6D00', '#FFD600', '#AEEA00', '#00C853'];

  passwordvalidationMsg = [];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    private dataService: DataService,
    private authService: AuthService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.passwordvalidationMsg.push('Password must:');
    this.passwordvalidationMsg.push('Be between 8-20 characters in length');
    this.passwordvalidationMsg.push('Include one upper case character');
    this.passwordvalidationMsg.push('Include one lower case character');
    this.passwordvalidationMsg.push('Include one numeric character');
    this.passwordvalidationMsg.push('Include one special character');
    this.passwordvalidationMsg.push('Not be one of the last 6 passwords used');
    this.passwordvalidationMsg.push('Not contain your first or last name');

  }

  ngOnInit() {

    this.http.get<any>(this.ServerConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            if(data.roles[0].id !== 5){
              this.router.navigate(['dashboard']);
            }
          }}
              this.resetPasswordVO = new ResetPasswordVO();
              this.user = new User();
              this.sharedData = this.dataService.getSharedDataObject();
              this.user.username = this.sharedData.get('username');
              this.firstName = this.sharedData.get('firstName');
              this.lastName = this.sharedData.get('lastName');
              this.tempPasswordSw = this.sharedData.get('tempPasswordSw');

              this.isResetDisable = false;
              this.load();
             
  }, response => {
console.log('error', response);
if(response.status === 401){
this.router.navigate(['dashboard']);
}
}, () => {

});

  }

  load() {

    this.http.post<User>(this.ServerConstants.SERVER_API_URL + '/user/user', this.user)
      .subscribe(
        (res: User) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Password Reset', this.userActionNotificationsMap.ERROR);
          } else {
            this.user = res;
            this.resetPasswordVO.userId = this.user.id;
            this.tempPasswordSw = this.user.tempPasswordSw;
            this.firstName = this.user.firstName;
            this.lastName = this.user.lastName;
            if (this.tempPasswordSw === 'N') {
              this.resetPasswordVO.verficationCode = true;
            }
          }
        },
        (response) => {
          this.notificationService.error('Password Reset', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }
  save() {
    this.resetPasswordVO.tempPasswordSw = 'N';
    this.http.post<ResetPasswordVO>(this.ServerConstants.SERVER_API_URL + '/user/reset', this.resetPasswordVO)
      .subscribe(
        (res: ResetPasswordVO) => {
          if (res.hasOwnProperty('errorCode')) {
            // res.errorCode[0].desc
            this.notificationService.error('Password Reset', this.userActionNotificationsMap.ERROR);
          } else {
            this.resetPasswordVO = res;
            if (!this.resetPasswordVO.currentPasswordSw) {
              if (this.resetPasswordVO.tempPasswordExpired) {
                this.authService.signOut();
                this.router.navigate(['SNAPWorks/providerportal']);
                this.notificationService.error('Password Reset', 'Your temporary password has expired.');
              } else if (this.resetPasswordVO.lastSixPassSW) {
                this.notificationService.warn('Password Reset', 'Your new password matches with your last 6 passwords');
              } else {
                this.authService.signOut();
                this.router.navigate(['SNAPWorks/providerportal']);
                this.notificationService.success('Password Reset', 'Your new password reset completed successfully');
              }
            } else {
              this.notificationService.warn('Password Reset', 'Current password did not match.');
            }

          }
        },
        (response) => {
          this.notificationService.error('Password Reset',  this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }
  reset() {
    if (this.dataService.getSharedDataObject().get("tempPasswordSw") === 'N') {
      this.router.navigate(['/']);
    } else {
      this.authService.signOut();
      this.router.navigate(['SNAPWorks/providerportal']);
    }
  }
  onBlurMethod() {
    if (this.reTypePassword !== undefined &&
      this.resetPasswordVO.password !== undefined) {
      if (this.resetPasswordVO.password === this.reTypePassword) {
        this.isSaveDisable = false;
      } else {
        this.isSaveDisable = true;
        this.notificationService.warn('Password Reset', 'New Password  does not match with Re-type Password');
      }
    }
  }
  onBlurPassword() {
    const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/;
    if (this.resetPasswordVO.password !== undefined) {
      const result = pattern.test(this.resetPasswordVO.password);
      if (!result) {
        this.isSaveDisable = true;


      }
      const firstNamePtrn = new RegExp(this.firstName);
      const result2 = firstNamePtrn.test(this.resetPasswordVO.password);
      const lastNamePtrn = new RegExp(this.lastName);
      const result3 = lastNamePtrn.test(this.resetPasswordVO.password);
      if (result2 || result3) {
        this.isSaveDisable = true;
        this.notificationService.warn('Password Reset', 'The new password cannot contain the user’s first or last name');
      }
      if (result && !result2 && !result3) {
        this.isSaveDisable = false;
      }
    }
  }

  onBlurTempPaswordCheckMethod() {
    if (this.confirmTempPassword !== undefined &&
      this.resetPasswordVO.password !== undefined) {
      if (this.resetPasswordVO.password === this.confirmTempPassword) {
        this.isSaveDisable = false;
      } else {
        this.isSaveDisable = true;
        this.notificationService.warn('Password Reset', 'Temp Password does not match with Confirm Temp Password');
      }
    }
  }

  onBlurNewPaswordCheckMethod() {
    if (this.confirmNewPassword !== undefined &&
      this.resetPasswordVO.password !== undefined) {
      if (this.resetPasswordVO.password === this.confirmNewPassword) {
        this.isSaveDisable = false;
      } else {
        this.isSaveDisable = true;
        this.notificationService.warn('Password Reset', 'New Password  does not match with Confirm New Password');
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts